import React from "react";
import "./style.scss";
import PropTypes from "prop-types";
export default function JoinGameSteps({ currentStep = 1 }) {
  JoinGameSteps.propTypes = {
    currentStep: PropTypes.number,
  };

  const getActiveStepClass = (className, step) => {
    const active = step <= currentStep ? `${className}_active` : "";

    return `${className} ${active}`;
  };

  return (
    <div className="steps-container">
      <div className={getActiveStepClass("steps-container__step", 1)}>1</div>
      <div className={getActiveStepClass("steps-container__line", 2)}></div>
      <div className={getActiveStepClass("steps-container__step", 2)}>2</div>
      <div className={getActiveStepClass("steps-container__line", 3)}></div>
      <div className={getActiveStepClass("steps-container__step", 3)}>3</div>
    </div>
  );
}
